// Investigation for manual enrolment

/**
 * Domain types for the passkey enrollment flow.
 *
 * This slice backs the `/add-passkey` screen, which another application can send
 * users to when they should enroll a passkey on the current device.
 */

export const PASSKEY_FLOW_RESET = "PASSKEY_FLOW_RESET";
export const PASSKEY_ENROLLMENT_STARTED = "PASSKEY_ENROLLMENT_STARTED";
export const PASSKEY_ENROLLMENT_SUCCEEDED = "PASSKEY_ENROLLMENT_SUCCEEDED";
export const PASSKEY_ENROLLMENT_FAILED = "PASSKEY_ENROLLMENT_FAILED";
export const PASSKEY_ENROLLMENT_UNSUPPORTED = "PASSKEY_ENROLLMENT_UNSUPPORTED";

/**
 * `idle`        - waiting for the user to decide.
 * `working`     - the WebAuthn ceremony is in flight; the browser is showing
 *                 its own native dialog, so our UI must stay out of the way.
 * `enrolled`    - a passkey now exists on this device. Reached either by a
 *                 successful ceremony OR by `InvalidStateError`, which means
 *                 one was already here (see `PasskeyEnrollmentError`).
 * `unsupported` - this browser/device cannot do platform passkeys at all.
 * `error`       - something went wrong; the user can retry or skip.
 */
export type PasskeyEnrollmentStatus = "idle" | "working" | "enrolled" | "unsupported" | "error";

export interface PasskeyFlowState {
    status: PasskeyEnrollmentStatus;
    /** Key into `errorCodeKeys` for a translated message. Null when there is no error. */
    errorCode: string | null;
}

export interface PasskeyFlowActionType {
    type:
        | typeof PASSKEY_FLOW_RESET
        | typeof PASSKEY_ENROLLMENT_STARTED
        | typeof PASSKEY_ENROLLMENT_SUCCEEDED
        | typeof PASSKEY_ENROLLMENT_FAILED
        | typeof PASSKEY_ENROLLMENT_UNSUPPORTED;
    payload: string | null;
}
